module.exports = require("./lrc-IQ.d.ts");